"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetalhesSumarioAtendimentos = void 0;
var React = require("react");
var microsoftTeams = require("@microsoft/teams-js");
var react_northstar_1 = require("@fluentui/react-northstar");
require("../visao-geral-atendimentos/detalhes-sumario-atendimento.scss");
var serventias_api_1 = require("../../../api/serventias-api");
var loaderDetalhesSumarioAtendimento_1 = require("../../loaders/loaderDetalhesSumarioAtendimento");
var qs = require("query-string");
var DetalhesSumarioAtendimentos = /** @class */ (function (_super) {
    __extends(DetalhesSumarioAtendimentos, _super);
    function DetalhesSumarioAtendimentos(props) {
        var _this = _super.call(this, props) || this;
        _this.qs = null;
        /**
         * Get Other Metrics Data
         * */
        _this.getOtherMetrics = function () { return __awaiter(_this, void 0, void 0, function () {
            var responseRequests, responseMeetings, responseMeetings7days;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, serventias_api_1.getLastRequestsLast7Days()];
                    case 1:
                        responseRequests = _a.sent();
                        if (responseRequests.status === 200 && responseRequests.data) {
                            this.setState({
                                requestsLast7Days: responseRequests.data,
                                loadingRequestLast7Days: false
                            });
                        }
                        return [4 /*yield*/, serventias_api_1.getIndexedMeetings()];
                    case 2:
                        responseMeetings = _a.sent();
                        if (responseMeetings.status === 200 && responseMeetings.data) {
                            this.setState({
                                indexedMeetings: responseMeetings.data,
                                loadingIndexedMeetings: false
                            });
                        }
                        return [4 /*yield*/, serventias_api_1.getMeetingsLast7Days()];
                    case 3:
                        responseMeetings7days = _a.sent();
                        if (responseMeetings7days.status === 200 && responseMeetings7days.data) {
                            this.setState({
                                meetingsLast7Days: responseMeetings7days.data,
                                loadingMeetingsLast7Days: false
                            });
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            loading: false,
            requestsLast7Days: [],
            loadingRequestLast7Days: true,
            indexedMeetings: [],
            loadingIndexedMeetings: true,
            meetingsLast7Days: [],
            loadingMeetingsLast7Days: true
        };
        _this.qs = qs.parse(_this.props.location.search);
        return _this;
    }
    DetalhesSumarioAtendimentos.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                microsoftTeams.initialize();
                this.getOtherMetrics();
                return [2 /*return*/];
            });
        });
    };
    DetalhesSumarioAtendimentos.prototype.formatDataNumber = function (number) {
        if (number)
            return new Intl.NumberFormat('pt-BR').format(number);
        else
            return 0;
    };
    DetalhesSumarioAtendimentos.prototype.render = function () {
        if (this.state.loadingRequestLast7Days || this.state.loadingIndexedMeetings || this.state.loadingMeetingsLast7Days) {
            return (React.createElement(loaderDetalhesSumarioAtendimento_1.default, null));
        }
        else {
            return (React.createElement("div", { className: "taskModuleDetalhes" },
                React.createElement(react_northstar_1.Flex, { column: true },
                    React.createElement(react_northstar_1.Flex, { style: {
                            minHeight: 70,
                        }, column: true },
                        React.createElement(react_northstar_1.Text, { size: "larger", content: this.qs.iniciados }),
                        React.createElement(react_northstar_1.Text, { size: "small", content: "Atendimentos iniciados" })),
                    React.createElement(react_northstar_1.Flex, { style: {
                            minHeight: 70,
                        }, column: true },
                        React.createElement(react_northstar_1.Text, { size: "larger", content: this.qs.avg }),
                        React.createElement(react_northstar_1.Text, { size: "small", content: "M\u00E9dia de Atendimentos Iniciados" })),
                    React.createElement(react_northstar_1.Flex, { style: {
                            minHeight: 70,
                        }, column: true },
                        React.createElement(react_northstar_1.Text, { size: "larger", content: this.state.requestsLast7Days.total }),
                        React.createElement(react_northstar_1.Text, { size: "small", content: "Atendimentos iniciados nos \u00FAltimos 7 dias" })),
                    React.createElement(react_northstar_1.Flex, { style: {
                            minHeight: 70,
                        }, column: true },
                        React.createElement(react_northstar_1.Text, { size: "larger", content: this.state.indexedMeetings.total }),
                        React.createElement(react_northstar_1.Text, { size: "small", content: "Serventias cadastradas" })),
                    React.createElement(react_northstar_1.Flex, { style: {
                            minHeight: 70,
                        }, column: true },
                        React.createElement(react_northstar_1.Text, { size: "larger", content: this.state.meetingsLast7Days.total ? this.state.meetingsLast7Days.total.length : "" }),
                        React.createElement(react_northstar_1.Text, { size: "small", content: "Serventias ativas nos \u00FAltimos 7 dias" })))));
        }
    };
    DetalhesSumarioAtendimentos.prototype.escFunction = function (event) {
        if (event.keyCode === 27 || (event.key === "Escape")) {
            microsoftTeams.tasks.submitTask();
        }
    };
    return DetalhesSumarioAtendimentos;
}(React.Component));
exports.DetalhesSumarioAtendimentos = DetalhesSumarioAtendimentos;
//# sourceMappingURL=detalhes-sumario-atendimentos.js.map